

import { styled, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import { AppIconsInstalledBase } from "../../../components/AppIcons";

export const Root = styled("div", { label: "InstalledBasePage" })
  ((theme) => ({
    display: "flex",
    flex: 1,
    flexGrow: 1,
    flexDirection: "column",
  }));

export const Content = styled("div", { label: "InstalledBasePage-Content" })
  ((theme) => ({
    overflow: "auto",
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 330px)',
    minHeight: 50,
  }));


export const Container = styled("div", { label: "InstalledBasePage-Container" })
  ((theme) => ({
    width: '100%',
    maxWidth: "calc(" + MiscSavio.maxWidth1500 + "px + 20px)",
    paddingLeft: 10,
    paddingRight: 10,
    margin: "0 auto",

  }));

export const PageTitle = styled("div", { label: "InstalledBasePage-pageTitle" })(({ theme }) => ({
  display: "flex",
  padding: "6px 0",
  color: StyleguideSavioColors.text.grayTitles,
  fontSize: 20,
  fontWeight: StyleguideSavioFonts.bold,
  alignItems: 'center',
})
);

export const SwitchContainer = styled("div", { label: "InstalledBasePage-switchContainer" })(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontWeight: StyleguideSavioFonts.medium,
  fontSize: 14,

})
);


export const IconInstalledBase = styled(AppIconsInstalledBase, { label: "InstalledBasePage-iconInstalledBase" })(({ theme }) => ({
  fontSize: 34,
  marginRight: 5,
  color: StyleguideSavioColors.grayBreadcrumb,
})
);

export const useClasses = () => {
  const theme = useTheme();
  const classes = {
    container: {
    } as SxProps,
  };
  return classes;
};
